<template>
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        close-on-content-click
        :timeout="snackbar.timeout"
        location="bottom"
    >
        {{ snackbar.text }}
    </v-snackbar>
</template>

<script setup>
import { useSnackbarStore } from '@/js/stores/snackbarStore'
const snackbar = useSnackbarStore()
</script>
